import { axiosInstance } from "lib/axios";
import { authAPI, searchAPI } from "services/apis.service";

export const getPublicCollections = async (user, filter, signal) => {
  const { data } = await axiosInstance.post(
    searchAPI.getPublicCollections,
    {
      filter: filter,
    },
    {
      cache: false,
      signal: signal,
    }
  );
  return data;
};

export const getPublicCollectionsSource = async (user, id) => {
  const { data } = await axiosInstance.post(
    searchAPI.getPublicCollectionsSource,
    {
      publicCollectionId: id,
    },
    {
      cache: true,
    }
  );

  return data;
};

export const getPublicCollectionOverview = async (user, id) => {
  const { data } = await axiosInstance.post(
    searchAPI.publicCollectionOverView,
    {
      publicCollectionId: id,
    }
  );

  return data;
};

export const publicCollectionCopy = async (user, id) => {
  const { data } = await axiosInstance.post(
    searchAPI.copyPublicCollection,
    {
      publicCollectionId: id,
      destinationUserID: user.userId,
    },
    { cache: false }
  );

  return data;
};